import React from 'react'

import { useTranslation } from 'react-i18next'

import { FilterOperatorSelectorProps } from './types'
import { useFilterConditionContext } from './useFilterCondition'
import { FieldLabel } from '@/Atomic/Atoms/FieldLabel'
import { BasicSelect } from '@/Atomic/Atoms/Inputs/BasicSelect'

/**
 * FilterOperatorSelector - Handles operator selection
 * Displays a dropdown to select filter operator (eq, neq, contains, etc.)
 */
export const FilterOperatorSelector: React.FC<
  FilterOperatorSelectorProps
> = () => {
  const { t } = useTranslation()
  const { condition, isFirstRow, availableOperators, handleOperatorChange } =
    useFilterConditionContext()

  return (
    <div className="form-field operator-selector">
      {isFirstRow && (
        <FieldLabel
          name={`operator-${condition.id}`}
          label={t('filter.condition')}
        />
      )}
      <BasicSelect
        key={`operator-${condition.id}-${condition.field}`}
        name={`operator-${condition.id}`}
        options={availableOperators}
        value={availableOperators.find((op) => op.value === condition.operator)}
        onChange={(option: unknown) =>
          handleOperatorChange((option as { value: string })?.value)
        }
        isClearable={false}
        isDisabled={!condition.field}
        isSearchable={false}
      />
    </div>
  )
}
